export const getObjectSnappingEdges = (node, stage) => {
  const box = node.getClientRect({relativeTo: stage})
  return {
    vertical: [
      {
        guide: Math.round(box.x),
        offset: Math.round(node.x() - box.x),
        snap: 'start'
      },
      {
        guide: Math.round(box.x + box.width / 3),
        offset: Math.round(node.x() - box.x - box.width / 3),
        snap: '1/3'
      },
      {
        guide: Math.round(box.x + box.width / 2),
        offset: Math.round(node.x() - box.x - box.width / 2),
        snap: 'center'
      },
      {
        guide: Math.round(box.x + (box.width * 2) / 3),
        offset: Math.round(node.x() - box.x - (box.width * 2) / 3),
        snap: '2/3'
      },
      {
        guide: Math.round(box.x + box.width),
        offset: Math.round(node.x() - box.x - box.width),
        snap: 'end'
      }
    ],
    horizontal: [
      {
        guide: Math.round(box.y),
        offset: Math.round(node.y() - box.y),
        snap: 'start'
      },
      {
        guide: Math.round(box.y + box.height / 3),
        offset: Math.round(node.y() - box.y - box.height / 3),
        snap: '1/3'
      },
      {
        guide: Math.round(box.y + box.height / 2),
        offset: Math.round(node.y() - box.y - box.height / 2),
        snap: 'center'
      },
      {
        guide: Math.round(box.y + (box.height * 2) / 3),
        offset: Math.round(node.y() - box.y - (box.height * 2) / 3),
        snap: '2/3'
      },
      {
        guide: Math.round(box.y + box.height),
        offset: Math.round(node.y() - box.y - box.height),
        snap: 'end'
      }
    ]
  }
}



// WEBPACK FOOTER //
// ./src/components/schemaFonctionnel/helper/getObjectSnappingEdges.js